import { render } from "./BackIcon.vue?vue&type=template&id=7b424948"
import script from "./BackIcon.vue?vue&type=script&lang=js"
export * from "./BackIcon.vue?vue&type=script&lang=js"
script.render = render

export default script